import type { IncidentSeverity, MonitorStatus } from "@/api/generated";
import { SEVERITY, STATUS } from "@/lib/status";
import { cn } from "@/lib/utils";

export function StatusIcon({ status, className }: { status: MonitorStatus; className?: string }) {
  const meta = STATUS[status];
  const Icon = meta.icon;
  return <Icon aria-label={meta.label} className={cn("size-4 shrink-0", meta.text, className)} />;
}

/** Colour + icon + label: status is never conveyed by colour alone. */
export function StatusBadge({ status, className, compact }: { status: MonitorStatus; className?: string; compact?: boolean }) {
  const meta = STATUS[status];
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-md border px-1.5 py-0.5 text-xs font-medium",
        "border-current/25 bg-current/10",
        meta.text,
        className,
      )}
      title={meta.label}
    >
      <StatusIcon status={status} className="size-3.5" />
      {!compact && <span>{meta.label}</span>}
    </span>
  );
}

export function SeverityBadge({ severity, className }: { severity: IncidentSeverity; className?: string }) {
  return <StatusBadge status={SEVERITY[severity].status} className={className} />;
}

/** A small dot + icon for dense rows (per-probe states). */
export function StatusDot({ status, title }: { status: MonitorStatus; title?: string }) {
  const meta = STATUS[status];
  const Icon = meta.icon;
  return (
    <span title={title ?? meta.label} className={cn("inline-flex items-center", meta.text)}>
      <Icon className="size-3.5" aria-label={title ?? meta.label} />
    </span>
  );
}
